import {
  recognitionCardsService,
  FetchRecognitionCardsRequest,
  RecognitionCardsResponse,
  useToast,
} from '@aslanpay/portal-common-lib';
import { useQuery } from '@tanstack/react-query';

const useFetchRecognitionCards = (params?: FetchRecognitionCardsRequest, enabled = true) => {
  const toast = useToast();

  return useQuery<RecognitionCardsResponse, Error>({
    queryKey: ['fetchRecognitionCards', params?.companyId, params?.usage],
    queryFn: () => recognitionCardsService.fetchRecognitionCards(params),
    enabled,
    onError: () => {
      toast({
        position: 'top-right',
        status: 'error',
        title: 'Something went wrong',
        description: 'Failed to load recognition cards. Please try again.',
      });
    },
  });
};

export default useFetchRecognitionCards;
